import React, {FC} from 'react';
import {ExpirationDatePicker} from './ExpirationDatePicker';
import {IWithDisabled} from 'models/common';

type IEditableExpirationDatePickerProps = IWithDisabled;

export const EditableExpirationDatePicker: FC<IEditableExpirationDatePickerProps> = ({disabled}) => {
  return <ExpirationDatePicker disablePast={false} disabled={disabled} />;
};
